import styled, { css } from "styled-components";
import Devices from "../../../../const/devices";
import { designTokens } from "../../../ui/foundation/DesignTokens";

export const InputContainer = styled.div`
  ${(props) =>
    props.fillFlex &&
    css`
      flex-grow: 1;
    `}
  position: relative;
`;

export const InputForm = styled.div`
  display: flex;
  align-items: center;
  height: 2.5rem;
  width: 100%;
  border-radius: ${designTokens.radius.md};
  padding: 0.6rem 0;

  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 400;
  font-size: ${designTokens.fontSizes.sm};
  line-height: 150%;
  background-color: ${(props) => {
    if (props.error && !props.onboardingLabelStyle) {
      if (!props.newTheme) return designTokens.colors.error[50];
      if (props.newTheme) return designTokens.colors.error[400];
    }
    if (props.disabled) return "transparent";
    return designTokens.colors.gray[100];
  }};
  padding: 0.6rem 0;
  margin-top: 1rem;

  ${(props) =>
    props.broadcastName &&
    css`
      width: 100%;
      height: 38px;

      margin-top: 0;
      margin-left: 0.25rem;

      border: 2px solid ${designTokens.colors.gray[200]};
      border-radius: ${designTokens.radius.sm};
      background-color: white;

      font-family: ${designTokens.fonts.body};
      font-style: normal;
      font-weight: 400;
      font-size: ${designTokens.fontSizes.sm};
      line-height: 150%;

      display: flex;
      align-items: center;
      letter-spacing: -0.257238px;

      color: ${designTokens.colors.gray[800]};

      padding-left: 0.5rem;

      flex: none;
      order: 0;
      flex-grow: 0;
    `}
`;

export const InputLabel = styled.label`
  font-size: ${designTokens.fontSizes.sm};
  opacity: 0.5;
  font-family: ${designTokens.fonts.body};
  ${(props) =>
    props.newTemplate &&
    css`
      font-family: ${designTokens.fonts.body};
      opacity: 1;
      font-style: normal;
      font-weight: 500;
      font-size: ${designTokens.fontSizes.sm};
      line-height: 24px;

      letter-spacing: -0.32px;

      color: ${designTokens.colors.gray[500]};
      margin-right: 98px;
      @media (min-width: 1500px) {
        margin-right: ${(props) => (props.variable ? "0" : "145px")};
      }
      @media (min-width: 1600px) {
        margin-right: ${(props) => (props.variable ? "0" : "230px")};
      }
      @media (min-width: 1900px) {
        margin-right: ${(props) => (props.variable ? "0" : "260px")};
      }
      @media ${Devices.desktop} {
        margin-right: ${(props) => (props.variable ? "0" : "290px")};
      }
    `}
  ${(props) =>
    props.broadcastName &&
    css`
      position: absolute;
      top: -14px;
      left: 12px;
      background: white;
      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: ${designTokens.fontSizes.xs};
      line-height: 150%;
      opacity: 1;
      padding-top: 0.25rem;

      letter-spacing: -0.257238px;

      color: ${designTokens.colors.gray[800]};
    `}

  ${(props) =>
    props.followUp &&
    css`
      margin-left: 2.625rem;
    `}
`;

export const InputIcon = styled.img`
  margin-left: 1rem;
  width: 1.5rem;
`;

export const InputValue = styled.input`
  font-family: ${(props) =>
    props.inputValueBold ? designTokens.fonts.heading : designTokens.fonts.body};
  font-size: ${designTokens.fontSizes.base};
  background: none;
  border: none;
  margin-left: 1rem;
  flex-grow: 2;

  ${(props) =>
    props.error &&
    props.newTheme &&
    css`
      color: white;
    `}

  &:focus {
    outline: none;
  }

  &::placeholder {
    ${(props) =>
      props.error && props.newTheme
        ? css`
            color: white;
            opacity: 0.6;
          `
        : css`
            opacity: 0.3;
          `}
  }

  @media (min-width: 300px) {
    width: 103%;
  }

  ${(props) =>
    props.broadcastName &&
    css`
      font-family: ${designTokens.fonts.body};
      font-style: normal;
      font-size: ${designTokens.fontSizes.sm};
      line-height: 150%;

      display: flex;
      align-items: center;
      letter-spacing: -0.257238px;

      color: ${designTokens.colors.gray[800]};

      margin-left: 0.25rem;
    `}
`;

export const InputError = styled.div`
  ${(props) =>
    props.onboardingLabelStyle
      ? css`
          font-family: ${designTokens.fonts.body};
          font-style: normal;
          font-weight: 600;
          font-size: ${designTokens.fontSizes.xs};
          line-height: 20px;
          letter-spacing: -0.257238px;
          color: ${designTokens.colors.error[500]};
        `
      : css`
          font-size: ${designTokens.fontSizes.base};
          color: ${designTokens.colors.error[500]};
        `}
`;

export const InputMidWidthContainer = styled.div`
  width: 70%;
  margin-bottom: 2rem;
`;

export const FullWidthContainer = styled.div`
  margin-top: 80px;
  display: flex;
  width: 100%;

  @media (max-width: 1200px) {
    margin-top: 120px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    margin-top: 170px;
  }
`;

export const Row = styled.div`
  width: 50%;
  ${(props) =>
    props.messagesDetails &&
    css`
      padding: 0 1rem;

      @media (min-width: 1400px) {
        padding: 0 2rem;
      }

      @media (max-width: 1200px) {
        padding: 0 1.5rem;
        width: 54%;
      }

      @media (max-width: 1024px) {
        order: -1;
        width: 100%;
        margin-bottom: 2rem;
      }
    `}
  ${(props) =>
    props.form &&
    css`
      @media (max-width: 1200px) {
        width: 44%;
      }
    `}
`;

export const OnboardingStyleError = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;

export const OnboardingErrorIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
